var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "pageTitle"
  }, [_vm._v("原始資料下載")]), _c('div', {
    staticClass: "borderColor mb-4 p-3"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-items-start"
  }, [_c('div', {
    staticClass: "field mr-4"
  }, [_c('label', {
    staticClass: "fieldLabel"
  }, [_vm._v("案場")]), _c('multiselect', {
    staticClass: "factorySelect",
    attrs: {
      "options": _vm.factoryOptions,
      "label": "label",
      "track-by": "value",
      "placeholder": "輸入或選擇案場",
      "max-height": 420,
      "allow-empty": false,
      "show-labels": false
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(props) {
        return [_c('span', [_vm._v(_vm._s(props.option.label))]), _c('span', {
          staticClass: "optionId"
        }, [_vm._v(_vm._s(props.option.value.split('_').pop()))])];
      }
    }]),
    model: {
      value: _vm.selectedFactory,
      callback: function callback($$v) {
        _vm.selectedFactory = $$v;
      },
      expression: "selectedFactory"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("查無此案場")])])], 1), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "fieldLabel"
  }, [_vm._v(" 日期區間 "), _c('span', {
    staticClass: "fieldHint"
  }, [_vm._v("最多 " + _vm._s(_vm.maxDays) + " 天")])]), _c('date-picker', {
    staticClass: "rangePicker",
    attrs: {
      "range": "",
      "value-type": "format",
      "format": "YYYY-MM-DD",
      "disabled-date": _vm.isDateAfterToday,
      "clearable": false,
      "placeholder": "選擇開始與結束日期"
    },
    model: {
      value: _vm.dateRange,
      callback: function callback($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c('div', {
    staticClass: "presetRow"
  }, _vm._l(_vm.datePresets, function (p) {
    return _c('button', {
      key: p.label,
      staticClass: "presetChip",
      class: {
        active: _vm.activePreset === p.label
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.applyPreset(p);
        }
      }
    }, [_vm._v(" " + _vm._s(p.label) + " ")]);
  }), 0)], 1)]), _c('div', {
    staticClass: "itemsBlock",
    class: {
      isEmpty: !_vm.optionGroups.length
    }
  }, [!_vm.optionGroups.length ? _c('div', {
    staticClass: "emptyHint"
  }, [_c('i', {
    staticClass: "fas fa-arrow-up mr-2"
  }), _vm._v("先選一個案場，這裡會列出可下載的項目 ")]) : [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('label', {
    staticClass: "fieldLabel mb-0"
  }, [_vm._v("下載項目")]), _c('button', {
    staticClass: "linkBtn ml-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.setAll(true);
      }
    }
  }, [_vm._v(" 全選 ")]), _c('button', {
    staticClass: "linkBtn ml-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.setAll(false);
      }
    }
  }, [_vm._v(" 全部清除 ")]), _c('span', {
    staticClass: "selectedCount ml-auto"
  }, [_vm._v(" 已選 " + _vm._s(_vm.selected.length) + " / " + _vm._s(_vm.allOptionValues.length) + " ")])]), _vm._l(_vm.optionGroups, function (group) {
    return _c('div', {
      key: group.key,
      staticClass: "optionGroup"
    }, [_c('div', {
      staticClass: "groupHead"
    }, [_c('span', {
      staticClass: "groupTitle"
    }, [_vm._v(_vm._s(group.title))]), _c('button', {
      staticClass: "linkBtn ml-2",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleGroup(group);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.isGroupAllSelected(group) ? '取消' : '全選') + " ")])]), _c('b-form-checkbox-group', {
      staticClass: "optionGrid",
      class: {
        invGrid: group.key === 'inv'
      },
      attrs: {
        "options": group.items
      },
      model: {
        value: _vm.selected,
        callback: function callback($$v) {
          _vm.selected = $$v;
        },
        expression: "selected"
      }
    })], 1);
  })]], 2), _c('div', {
    staticClass: "footerRow"
  }, [_c('div', {
    staticClass: "summary"
  }, [_vm.selectedFactory && _vm.selected.length ? [_vm._v(" 將下載 "), _c('strong', [_vm._v(_vm._s(_vm.days))]), _vm._v(" 天 × "), _c('strong', [_vm._v(_vm._s(_vm.selected.length))]), _vm._v(" 個項目 "), _vm.days > _vm.maxDays ? _c('span', {
    staticClass: "warn"
  }, [_vm._v(" — 超過 " + _vm._s(_vm.maxDays) + " 天上限 ")]) : _vm._e()] : [_vm._v(" 選好案場、日期與項目後即可下載 ")]], 2), _c('button', {
    staticClass: "confirmButton downloadBtn",
    class: {
      disableButton: !_vm.canDownload
    },
    attrs: {
      "disabled": !_vm.canDownload
    },
    on: {
      "click": _vm.download
    }
  }, [_vm.loadingData ? _c('i', {
    staticClass: "fas fa-circle-notch fa-spin mr-2"
  }) : _c('i', {
    staticClass: "fas fa-file-excel mr-2"
  }), _vm._v(" " + _vm._s(_vm.loadingData ? '產檔中…' : '下載 Excel') + " ")])]), _vm.loadingData ? _c('div', {
    staticClass: "loadingHint"
  }, [_vm._v(" 資料量大時檔案要跑一分鐘左右，請不要關閉頁面 ")]) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };